import classnames from "classnames";
import { useCallback, useMemo } from "react";
import { FormText, InputGroup, InputGroupText } from "reactstrap";
import { parseCurrencyToCents } from "../../../util/formatters";
import { InputWrapper } from "./InputWrapper";

export const MoneyInput = ({ children, input, label, meta, ...rest }) => {
  return (
    <InputWrapper label={label} required={rest.required}>
      <InputGroup>
        <InputGroupText>$</InputGroupText>
        <input
          {...input}
          type="number"
          inputMode="numeric"
          pattern="-?(?:0|[1-9]\d*)\.\d{2}"
          step="0.01"
          className={classnames("form-control", rest.className, {
            "is-invalid": Boolean(meta.touched && meta.error),
          })}
          {...rest}
        />
      </InputGroup>
      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}
      {children}
    </InputWrapper>
  );
};

export const CentsInput = ({ input, ...rest }) => {
  const handleChange = useCallback(
    (e) => {
      input.onChange(e.target.value == null ? e.target.value : parseCurrencyToCents(e.target.value));
    },
    [input]
  );

  const inputValue = useMemo(() => (input.value ? input.value / 100 : undefined), [input.value]);

  return <MoneyInput {...input} onChange={handleChange} value={inputValue} {...rest} />;
};
